module.exports = __webpack_public_path__ + "img/exclusive_icon.3020fc06.png";